<div class="eco-info-container pt-1 animated fadeIn">
  @if(ecoData()) {

    <!-- ── Section 1: Equipment ── -->
    <div class="kite-section-card">
      <div class="kite-section-title flex-wrap gap-2">
        <span>Equipment</span>
        <div class="section-actions">
          @if ((equipmentList.equipment()?.length || 0) > 0 && equipmentList.canCreate()) {
            <app-button size="sm" variant="primary" icon="fa fa-plus" (onClick)="equipmentList.openAdd()">
              Add Equipment
            </app-button>
          }
        </div>
      </div>
      <app-clean-equipment-list #equipmentList [clientId]="ecoData()!._id" [equipmentList]="cleanEquipment()"
        [onChanged]="onEquipmentChanged.bind(this)"></app-clean-equipment-list>
    </div>

    <!-- ── Section 2: ECO Agreement ── -->
    <div class="kite-section-card">
      <div class="kite-section-title flex-wrap gap-2">
        <span>ECO Agreement</span>
        <div class="section-actions">
          @if (editAgreementMode()) {
            <app-button size="sm" title="Save changes" [loading]="savingAgreement()" (click)="saveAgreement()">
              <i class="fa fa-save mr-1"></i>
              Save Changes
            </app-button>
            <app-button size="sm" variant="secondary" [disabled]="savingAgreement()" title="Discard changes" (click)="editAgreementMode.set(false)">
              <i class="fa fa-times mr-1"></i>
              Cancel
            </app-button>
          } @else {
            <app-button size="sm" variant="blue-text" title="Edit agreement information" (click)="toggleEditAgreement()">
              <i class="fa fa-edit mr-1"></i> Edit
            </app-button>
          }
        </div>
      </div>
      @if (!ecoFinancial()) {
        <div class="mt-3 p-4" style="background-color:#f8f9fa; border-radius:6px; text-align:center;">
          <i class="fa fa-info-circle text-muted mr-2"></i>
          <span class="text-muted">No ECO Agreement information configured for this client.</span>
        </div>
      } @else {
        <div class="row g-2 mt-1" [formGroup]="agreementForm">
          @if (editAgreementMode()) {
            <div class="col-xl-3 col-md-4 mb-2">
              <app-select 
                [control]="agreementForm.get('agreement_type')" 
                [source]="[{code:'rebate', name:'Rebate'}, {code:'free', name:'Free'}, {code:'flat', name:'Flat'}, {code:'pay_in_full', name:'Pay in Full'}]" 
                label="Agreement Method" 
                placeholder="Select method">
              </app-select>
            </div>
            <div class="col-xl-2 col-md-4 mb-2">
              <app-select 
                [control]="agreementForm.get('duration')" 
                [source]="ECO_DURATION_OPTIONS" 
                label="Duration" 
                placeholder="Select duration">
              </app-select>
            </div>
            <app-custom-input class="col-xl-2 col-md-4 mb-2" label="Price" [control]="agreementForm.get('price')" type="number"></app-custom-input>
            <app-custom-input class="col-xl-2 col-md-4 mb-2" label="Start Date" [control]="agreementForm.get('start_date')" type="date"></app-custom-input>
            <app-custom-input class="col-xl-2 col-md-4 mb-2" label="End Date" [control]="agreementForm.get('end_date')" type="date"></app-custom-input>
          } @else {
            <app-read-only-field label="Agreement Method" class="col-xl-3 col-md-4 mb-2" [value]="ecoFinancial()?.agreement_type   | titlecase"></app-read-only-field>
            <app-read-only-field label="Agreement Status" class="col-xl-2 col-md-4 mb-2" [value]="ecoFinancial()?.agreement_status  | titlecase"></app-read-only-field>
            <app-read-only-field label="Duration" class="col-xl-2 col-md-4 mb-2" [value]="formatDuration(ecoFinancial()?.duration)"></app-read-only-field>
            <app-read-only-field label="Price" class="col-xl-2 col-md-4 mb-2" [value]="ecoFinancial()?.price | currency"></app-read-only-field>
            <app-read-only-field label="Start & End Date" class="col-xl-3 col-md-4 mb-2" [value]="formatDate(ecoFinancial()?.start_date) + ' - ' + formatDate(ecoFinancial()?.end_date)"></app-read-only-field>
          }
        </div>
      }
      @if (resumeData?.clientInfomationTabData()?.status !== CustomerTypesEnum.Prospect){
        <div class="mt-3 text-end flex justify-content-end gap-2">
          <app-button variant="secondary" type="button" (onClick)="openBenefitsModal()">
            View Benefits
          </app-button>
          <app-button variant="secondary" type="button" [loading]="downloading()" (onClick)="downloadAgreement()">
            <i class="pr-2 fa fa-file-pdf-o" aria-hidden="true"></i>
            View Services Agreement
          </app-button>
        </div>
      }
    </div>
  } @else if (!loading()) {
    <!-- ── Empty State: No ECO Agreement ── -->
    <div class="kite-section-card mt-3">
      <div class="kite-section-title">
        <span>ECO Equipment & Agreement</span>
      </div>
      <div class="mt-2 p-5 rounded-xl" style="background-color: #ecf3fd;">
        <div class="text-center mx-auto">
          <i class="fa fa-exclamation-triangle fa-2x"></i>
          <div class="mt-2">
            <h5 class="mb-1 text-dark">This Client Doesn't Have ECO Equipment or an Agreement</h5>
            <span class="text-muted">Add this location's equipment, then complete the ECO agreement.</span>
          </div>
          <app-button *ngIf="permissions.canCreateEcoClient()" variant="primary" class="mt-4" type="button" (onClick)="openCreateEcoAgreement()">
            <i class="fa fa-plus mr-2" aria-hidden="true"></i> Set Up ECO Equipment
          </app-button>
        </div>
      </div>
    </div>
  } @else {
    <app-page-loading [absolute]="true"></app-page-loading>
  }
</div>


